module.exports = {"title":"A Customer Care Representative will be in touch.","information":"<0/> <1>{email}</1> <2 /> <3 />"}